import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { fetchPlot, saveEditData } from '../actions/plotAction';
import Layout from '../components/Layout/Layout';
import AddPlotForm from '../components/Plots/AddPlotForm';


const AddPlot = ( { plotEdit, loading, msg, isAuthenticated, fetchPlot }: any ) => {
    
    const [ edit, setEdit ] = useState( false );
    console.log( 'inside add plot', plotEdit );
    const queryParams = new URLSearchParams(window.location.search);
    const editCheck = queryParams.get('edit') ? true : false;
   
    useEffect( ( ) => { 
        setEdit( editCheck );
        console.log( "edit is: ", edit );
        
        if ( edit && plotEdit.length ) {

            console.log( 'edit: ', edit, plotEdit );

        }
        else {
            console.log( 'add: ', edit, plotEdit );
        }

    }, [ edit ] );

    return (
        
        <Layout>
            <AddPlotWrapper>
                <AddPlotForm plotEdit = { plotEdit } edit = { editCheck } />
            </AddPlotWrapper>
        </Layout>
    )
}

const mapStateToProps = ( state: any ) => ( { 

    isAuthenticated: state.admin.isAuthenticated,
    loading: state.plot.loading,
    msg: state.plot.msg,
    plotInfo: state.plot.plotInfo,
    plotEdit: state.plot.plotEdit

} );

export default connect( mapStateToProps, {

    fetchPlot,
    saveEditData    

} ) ( AddPlot );


const AddPlotWrapper = styled.div`


`;